import Swiper from "swiper";
import { A11y, Keyboard } from "swiper/modules";
import type { SwiperOptions } from "swiper/types";
// @ts-ignore
import "swiper/css/bundle";

export class Carousel {
  private element: HTMLElement;
  private swiper: Swiper | null = null;

  constructor(element: HTMLElement) {
    if (!!element) {
      this.element = element;

      this.init();
    }
  }

  private init() {
    this.initializeSwiper();
  }

  private initializeSwiper() {
    const swiperParams: SwiperOptions = {
      slidesPerView: "auto",
      spaceBetween: 22,
      freeMode: true,
      modules: [A11y, Keyboard],
      a11y: {
        enabled: true,
        nextSlideMessage: "Next",
        prevSlideMessage: "Previous",
      },
      keyboard: {
        enabled: true,
      },
    };

    this.swiper = new Swiper(this.element, swiperParams);
  }
}

export default function homeCardCarouselInit() {
  const carousel = document.querySelectorAll(
    ".home-card-carousel__card-set",
  ) as NodeListOf<HTMLElement>;
  for (let i = 0; i < carousel.length; i++) {
    new Carousel(carousel[i]);
  }
}
